import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Camada_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1030 1030",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        opacity: .9;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22 {\n        isolation: isolate;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23 {\n        fill: #334155;\n      }\n\n      .st1 {\n        opacity: 0;\n      }\n\n      .st2 {\n        opacity: .1;\n      }\n\n      .st3 {\n        opacity: .2;\n      }\n\n      .st4 {\n        opacity: .2;\n      }\n\n      .st5 {\n        opacity: .3;\n      }\n\n      .st6 {\n        opacity: .3;\n      }\n\n      .st7 {\n        opacity: .3;\n      }\n\n      .st8 {\n        opacity: .4;\n      }\n\n      .st9 {\n        opacity: .4;\n      }\n\n      .st10 {\n        opacity: .7;\n      }\n\n      .st11 {\n        opacity: .6;\n      }\n\n      .st12 {\n        opacity: .6;\n      }\n\n      .st13 {\n        opacity: .5;\n      }\n\n      .st14 {\n        opacity: .5;\n      }\n\n      .st15 {\n        opacity: .9;\n      }\n\n      .st16 {\n        opacity: .8;\n      }\n\n      .st17 {\n        opacity: .8;\n      }\n\n      .st18 {\n        opacity: .8;\n      }\n\n      .st19 {\n        opacity: .7;\n      }\n\n      .st20 {\n        opacity: 1;\n      }\n\n      .st21 {\n        opacity: .5;\n      }\n\n      .st22 {\n        opacity: 0;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("circle", {
			className: "st23",
			cx: 771.8,
			cy: 114.2,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st14",
			cx: 258.2,
			cy: 915.8,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st7",
			cx: 915.8,
			cy: 771.8,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st18",
			cx: 114.2,
			cy: 258.2,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st22",
			cx: 866.8,
			cy: 194.3,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st13",
			cx: 163.2,
			cy: 835.7,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st6",
			cx: 835.7,
			cy: 866.8,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st17",
			cx: 194.3,
			cy: 163.2,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st1",
			cx: 937.8,
			cy: 296.3,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st11",
			cx: 92.2,
			cy: 733.7,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st5",
			cx: 733.7,
			cy: 937.8,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st16",
			cx: 296.3,
			cy: 92.2,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st2",
			cx: 980,
			cy: 413.2,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st12",
			cx: 50,
			cy: 616.8,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st9",
			cx: 616.8,
			cy: 980,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st15",
			cx: 413.2,
			cy: 50,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st4",
			cx: 990.5,
			cy: 537,
			r: 37,
			transform: "translate(261.3 1395.9) rotate(-78.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st10",
			cx: 39.5,
			cy: 493,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st8",
			cx: 493,
			cy: 990.5,
			r: 37,
			transform: "translate(-519.2 1437.2) rotate(-87.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st0",
			cx: 537,
			cy: 39.5,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st3",
			cx: 968.6,
			cy: 659.3,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st19",
			cx: 61.4,
			cy: 370.7,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st21",
			cx: 370.7,
			cy: 968.6,
			r: 37
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st20",
			cx: 659.3,
			cy: 61.4,
			r: 37
		})
	]
});
export default SvgSpinner;
